export const visibleStreamBitrates = <T>(
  bitrates: T[],
  isStreamRunning: boolean,
): T[] => isStreamRunning ? bitrates : [];
